<template>
  <div class="smartVillage">
    <div class="module">
      <ul class="ul">
        <li class="li" v-for="(item, index) in moduleList" :key="index" @click="handleCaseClick">
          <div class="img">
            <img :src="item.img" alt="" />
          </div>
          <div class="name">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { enableCasePreview, getToken } from '@/utils/auth';

export default {
  name: 'smartVillage',
  data() {
    return {
      moduleList: [
        {
          img: require('./img/hxw.jpg'),
          name: '横溪坞'
        },
        {
          img: require('./img/hdc.jpg'),
          name: '黄杜村'
        },
        {
          img: require('./img/lj.jpg'),
          name: '鲁家'
        },
        {
          img: require('./img/wz.png'),
          name: '乌镇'
        },
        {
          img: require('./img/yc.jpg'),
          name: '余村'
        },
        {
          img: require('./img/ys.jpg'),
          name: '虞山'
        }
      ]
    };
  },
  methods: {
    handleCaseClick() {
      if (getToken()) {
        enableCasePreview();
        this.$emit('show-success');
        return;
      }
      this.$router.push('/login?redirect=%2Fcase&casePreview=1');
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.smartVillage {
  .module {
    margin: 0 auto;
    width: 100%;
    max-width: 100%;
    min-height: 546px;
    padding: 80px clamp(20px, 6vw, 120px);
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #979797;

    .ul {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 48px 24px;

      .li {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        padding: 0 12px;

        .img {
          img {
            width: clamp(72px, 6vw, 100px);
            height: clamp(72px, 6vw, 100px);
            object-fit: cover;
          }
        }

        .name {
          text-align: center;
          width: 100%;
          max-width: 300px;
          min-height: 33px;
          font-size: clamp(18px, 1.5vw, 24px);
          font-family: 'PingFang';
          color: #000000;
          line-height: 1.4;
          margin-top: 28px;
        }
      }
    }
  }
}

@media (max-width: 900px) {
  .smartVillage .module .ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .smartVillage .module {
    padding: 48px 16px;
  }

  .smartVillage .module .ul {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
</style>
